import { render, staticRenderFns } from "./CardEvent.vue?vue&type=template&id=32f7ba8c&scoped=true"
import script from "./CardEvent.vue?vue&type=script&lang=js"
export * from "./CardEvent.vue?vue&type=script&lang=js"
import style0 from "./CardEvent.vue?vue&type=style&index=0&id=32f7ba8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f7ba8c",
  null
  
)

export default component.exports